export enum ConsumerSearchCentersFilter {
  ALL = 'all',
  STAND = 'stand'
}
